import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const AnnounceServices = {

    getAllAnnounce: async () => {
        try {
            const response = await axios.get(ENDPOINT.Announce);
            return response.data;
        } catch (error) {
            console.error("Error fetching Announce:", error.message);
            throw error;
        }
    },

    getAllAnnounceById: async (id) => {
        try {
            const response = await axios.get(`${ENDPOINT.Announce}/Announces/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching Announce:", error.message);
            throw error;
        }
    },

    getAllActiveAnnounceById: async (id) => {
        try {
            const response = await axios.get(`${ENDPOINT.activeAnnounce}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching Announce:", error.message);
            throw error;
        }
    },

    createAnnounce: async (data) => {
        try {
            const response = await axios.post(ENDPOINT.Announce, data,
                { headers: { "Content-Type": "multipart/form-data" } });
            return response.data;
        } catch (error) {
            console.error("Error fetching Announce:", error.message);
            throw error;
        }
    },

    updateAnnounce: async ( id, data ) => {
        try {
            const response = await axios.put(`${ENDPOINT.Announce}/${id}`, data,
               { headers: { "Content-Type": "multipart/form-data" } });
            return response.data;
        } catch (error) {
            console.error("Error fetching Announce:", error.message);
            throw error;
        }
    },

    deleteAnnounce: async (id) => {
        try {
            const response = await axios.delete(`${ENDPOINT.Announce}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching quotation:", error.message);
            throw error;
        }
    },

}